import { ArrowUpRight } from "lucide-react";
import moment from "moment";
import React from "react";

function BlogCard({
  index,
  data,
  navigateButtonText,
  handleNavigate,
}: {
  index: number;
  data: any;
  navigateButtonText: string;
  handleNavigate: () => void;
}) {
  return (
    <div
      key={index}
      className="group relative overflow-hidden rounded-2xl sm:rounded-3xl bg-white/80 backdrop-blur-sm border border-gray-100/50 hover:border-gray-200/80 transition-all duration-700 hover:shadow-[0_20px_70px_-10px_rgba(0,0,0,0.1)] hover:-translate-y-2"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50/30 via-transparent to-purple-50/20 opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
      <div className="relative p-3 sm:p-4 md:p-6 lg:p-8">
        <div className="relative mb-4 sm:mb-6 md:mb-8 overflow-hidden rounded-xl sm:rounded-2xl bg-gray-50 border">
          <div className="relative hover:scale-105 transition-transform duration-700">
            <img
              className="w-full h-48 sm:h-52 md:h-60 lg:h-64 object-cover transition-all duration-700 group-hover:contrast-110 overflow-hidden"
              src={data?.poster_img_url}
              alt={data?.title}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </div>
        </div>

        <div className="space-y-3 sm:space-y-4 md:space-y-6">
          <div className="inline-flex items-center gap-2">
            <div className="w-1.5 h-1.5 rounded-full bg-secondary" />
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
              Author: {data.written_by}
            </span>
          </div>

          <h3 className="text-lg sm:text-xl md:text-2xl lg:text-2xl font-bold text-gray-900 leading-tight group-hover:text-gray-700 transition-colors duration-300 line-clamp-2">
            {data?.title}
          </h3>

          <div className="flex gap-3 sm:gap-4 flex-col sm:flex-row items-start sm:items-center justify-between">
            <p className="text-gray-600 leading-relaxed text-sm sm:text-base order-2 sm:order-1">
              {moment(data?.date).format("DD-MM-YYYY")}
            </p>
            {data?.industry && (
              <span className="px-2.5 sm:px-3 py-1 sm:py-1.5 bg-secondary/5 hover:bg-secondary/10 text-gray-700 rounded-full text-xs font-medium transition-colors duration-200 border border-gray-100 order-1 sm:order-2 self-start">
                {data?.industry}
              </span>
            )}
          </div>

          <div className="pt-2 sm:pt-3 md:pt-4">
            <button
              onClick={handleNavigate}
              className="group/button inline-flex items-center gap-2 sm:gap-3 text-sm font-semibold text-gray-900 hover:text-secondary transition-all duration-300 outline-none rounded-xl px-0 py-2 w-full sm:w-auto justify-center sm:justify-start"
            >
              <span className="relative">
                {navigateButtonText}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-secondary group-hover/button:w-full transition-all duration-300" />
              </span>
              <div className="relative">
                <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover/button:scale-110 group-hover/button:rotate-45" />
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogCard;
